function sleepAwait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default sleepAwait;
